import tools from "../../../helpers/tools";
import Control from "../../common/Control";
import Loader from "../../common/Loader";
import styles from "./QuotationActionBar.module.scss";

const QuotationActionBar = ({
  dur,
  setDur,
  km,
  setKm,
  selectedVehicle,
  quotationDetailActions,
  quotationSelected,
  quotationData,
  state,
  props,
}) => {
  const vehicleCount = selectedVehicle
    ? Object.keys(selectedVehicle).length
    : 0;
  const hasVehicle = vehicleCount > 0;
  const hasDur = dur != "0" && dur != "";
  const hasKm = km != "0" && km != "";
  const canAdd = hasVehicle && hasDur && hasKm;

  // Première étape manquante → message d'aide sous le bouton Ajouter.
  let hint = null;
  if (!hasVehicle) hint = "Choisissez un véhicule";
  else if (!hasDur) hint = "Renseignez une durée";
  else if (!hasKm) hint = "Renseignez un kilométrage";

  return (
    <div className={styles.bar}>
      {/* ── Construction d'une ligne ── */}
      <div className={styles.builder}>
        <div className={styles.step}>
          <span className={styles.stepLabel}>1 · Véhicule</span>
          <button
            type="button"
            className={`${styles.vehicleBtn} ${hasVehicle ? styles.filled : ""}`}
            data-toggle="modal"
            data-target="#catalogModal"
          >
            <i className="fa fa-car" />
            {hasVehicle
              ? `${vehicleCount} ${tools.getStringPlural(
                  "véhicule",
                  vehicleCount > 1
                )} ${tools.getStringPlural("choisi", vehicleCount > 1)}`
              : "Choisir des véhicules"}
          </button>
          {hasVehicle && (
            <div className={styles.chips}>
              {Object.keys(selectedVehicle).map((k) => {
                const sv = selectedVehicle[k];
                return (
                  <span className={styles.chip} key={k}>
                    {sv.brand?.name} {sv.brandModel?.name}
                  </span>
                );
              })}
            </div>
          )}
          {state.error.vehicle && (
            <span className={styles.vehicleError}>{state.error.vehicle}</span>
          )}
        </div>

        <div className={styles.step}>
          <span className={styles.stepLabel}>2 · Durée (mois)</span>
          <div className={styles.field}>
            <Control
              name="dur"
              id="dur"
              label=""
              value={dur}
              change={(e) => setDur(e.target.value)}
              onClick={() => {
                if (dur == "0") setDur("");
              }}
              onBlur={() => {
                if (dur == "") setDur("0");
              }}
            />
          </div>
        </div>

        <div className={styles.step}>
          <span className={styles.stepLabel}>3 · Kilométrage</span>
          <div className={styles.field}>
            <Control
              name="km"
              id="km"
              label=""
              value={km}
              change={(e) => setKm(e.target.value)}
              onClick={() => {
                if (km == "0") setKm("");
              }}
              onBlur={() => {
                if (km == "") setKm("0");
              }}
            />
          </div>
        </div>

        <div className={styles.step}>
          <span className={styles.stepLabel}>&nbsp;</span>
          <div className={styles.addGroup}>
            <button
              type="button"
              className={styles.addBtn}
              disabled={!canAdd}
              onClick={canAdd ? quotationDetailActions.addRollingLaw : undefined}
            >
              <i className="fa fa-plus" />
              {hasVehicle
                ? `Ajouter ${vehicleCount} loi(s) de roulage`
                : "Ajouter une loi de roulage"}
            </button>
            {hint && <span className={styles.hint}>{hint}</span>}
          </div>
        </div>
      </div>

      <div className={styles.separator} />

      {/* ── Actions dossier ── */}
      <div className={styles.dossierActions}>
        {state.quotation.isLoading ? (
          <Loader />
        ) : props.match.params.uuid == "create" ? (
          <button
            type="button"
            className={styles.saveBtn}
            onClick={() => quotationDetailActions.save("create")}
          >
            <i className="fa fa-check" />
            Créer le devis
          </button>
        ) : (
          <button
            type="button"
            className={styles.saveBtn}
            onClick={() => quotationDetailActions.save("update")}
          >
            <i className="fa fa-save" />
            Enregistrer le devis
          </button>
        )}
        {quotationSelected.length > 0 && (
          <button
            type="button"
            className={styles.pdfBtn}
            onClick={quotationDetailActions.openPdfQuotationList}
          >
            <i className="fa fa-file-pdf" />
            Voir les dossiers sélectionnés
          </button>
        )}
      </div>
    </div>
  );
};

export default QuotationActionBar;
